/* tslint:disable:max-line-length */
import React from 'react';
import { Template } from './Template';
import { Routes } from '../../routes/top-level-routes';
import { Link } from '@mm/components';

export const GDPR = () => (
  <div>
    <h1 style={{ marginBottom: '13px' }}>
      MobileMonkey, Inc. GDPR Processing Addendum
    </h1>

    <p>
      If you are not a member of the EU, then refer back to our Terms of
      Use&nbsp;
      <Link to={Routes.masterServiceAgreement.path}>here</Link>
    </p>
    <p>
      <span>
        <strong>MobileMonkey, Inc. GDPR Processing Addendum</strong>
      </span>
    </p>
    <p>
      <span>
        <em>Effective June 30, 2018</em>
      </span>
    </p>
    <ol>
      <li>
        <span>
          <strong> &nbsp;Preamble</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        1.1&nbsp; &nbsp; &nbsp;&nbsp;This Data Processing Addendum represents an
        addendum to MobileMonkey’s Master Service Agreement. Under the European
        Union General Data Protection Regulation (<strong>GDPR</strong>),
        MobileMonkey is the Processor and its clients are the Controller for the
        processing of Personal Data of EU/EEA residents by MobileMonkey on
        behalf of its clients.
      </span>
    </p>
    <p>
      <span>
        1.2&nbsp; &nbsp; &nbsp;This Data Processing Addendum is an integral part
        of and incorporated into the MSA.
      </span>
    </p>
    <p>
      <span>
        1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Reference is made to
        MobileMonkey’s GDPR-specific Privacy Policy{' '}
        <Link to={Routes.privacyPolicy.path} capitalize={false}>
          {Routes.privacyPolicy.getLink()}
        </Link>
        .
      </span>
    </p>
    <ol start={2}>
      <li>
        <span>
          <strong> Definitions</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        2.1&nbsp; &nbsp; &nbsp;The following definitions explain are used
        throughout this Addendum:
      </span>
    </p>
    <ul>
      <li>
        <span>
          <strong>“DPA</strong>” refers to this Data Processing Addendum.
        </span>
      </li>
      <li>
        <span>
          “<strong>MSA”</strong> refers to the MobileMonkey’s Master Service
          Agreement.
        </span>
      </li>
      <li>
        <span>
          “<strong>Processor</strong>” refers to MobileMonkey.
        </span>
      </li>
      <li>
        <span>
          “<strong>Controller</strong>” refers to you, MobileMonkey’s client,
          pursuant to the MSA and the party requesting the data processing that
          is the subject of this DPA.
        </span>
      </li>
      <li>
        <span>
          “<strong>Processing</strong>” refers to any operation or set of
          operations which is performed on personal data or on sets of personal
          data, whether or not by automated means, such as collection,
          recording, organization, structuring, storage, adaptation or
          alteration, retrieval, consultation, use, disclosure by transmission,
          dissemination or otherwise making available, alignment or combination,
          restriction, erasure or destruction.
        </span>
      </li>
      <li>
        <span>
          <strong>“Personal</strong> <strong>Data</strong>” refers to that
          information provided by Controller to the Processor relating to an
          identified or identifiable natural person; an identifiable natural
          person is one who can be identified, directly or indirectly, in
          particular by reference to an identifier such as a name, an
          identification number, location data, an online identifier or to one
          or more factors specific to the physical, physiological, genetic,
          mental, economic, cultural or social identity of that natural person.
        </span>
      </li>
      <li>
        <span>
          <strong>“Data Subject</strong>” refers to an identified or
          identifiable natural person to whom Data relates.
        </span>
      </li>
      <li>
        <span>
          <strong>“Data Breach</strong>” refers to a breach of security leading
          to the accidental or unlawful destruction, loss, alteration,
          unauthorized disclosure of, or access to, Personal Data transmitted,
          stored or otherwise processed
        </span>
      </li>
    </ul>
    <ol start={3}>
      <li>
        <span>
          <strong> Processing</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        3.1&nbsp; &nbsp; &nbsp;Processor undertakes to process all Personal Data
        in accordance with GDPR and other applicable laws, statutes and
        regulations.
      </span>
    </p>
    <p>
      <span>
        3.2&nbsp; &nbsp;&nbsp;Processor may process the Data only in accordance
        with the Controller’s documented instructions. Instructions referred to
        herein are incorporated into the MSA or may be contained within a
        separate Statement of Work or another written document concluded or
        exchanged between the Controller and the Processor.&nbsp; The Processing
        will take place in the United States.
      </span>
    </p>
    <p>
      <span>
        3.3&nbsp; &nbsp;During the term of this DPA, Controller shall remain the
        owner of the Personal Data transferred to the Processor. Nothing in this
        DPA shall be understood to transfer the ownership of the Personal Data
        to the Processor or any other third party.
      </span>
    </p>
    <p>
      <span>
        3.4&nbsp; &nbsp;Controller warrants that the Personal Data is obtained
        and provided to the Processor in accordance with the applicable laws,
        statutes and regulations and that the contemplated Processing requested
        by the Controller will not violate any applicable law, statute or
        regulation.&nbsp;
      </span>
    </p>
    <p>
      <span>
        3.5&nbsp;&nbsp; For Controllers located in the EU/EEA, the Standard
        Contractual Clauses adopted by the European Commission (available at:{' '}
        <a href="https://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX%3A32010D0087">
          https://eur-lex.europa.eu/legal-content/en/TXT/?uri=CELEX%3A32010D0087
        </a>
        ) are an integral part of and incorporated by reference into this DPA
        and shall apply to the Controller and Processor.
      </span>
    </p>
    <p>
      <span>
        3.6&nbsp;&nbsp; Personal Data may be processed by the Processor only
        during the duration of this DPA.
      </span>
    </p>
    <ol start={4}>
      <li>
        <span>
          <strong> Personnel</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        4.1&nbsp; &nbsp; &nbsp;The Processor shall ensure that all employees,
        contractors, and other persons operating under the authority of the
        Processor are bound by a strict confidentiality agreement prior to
        providing them with an access to the Personal Data.
      </span>
    </p>
    <p>
      <span>
        4.2&nbsp; &nbsp;The Processor shall take steps to ensure that any person
        acting under the authority of the Processor who has access to the Data
        does not process them except on instructions from the Controller.
      </span>
    </p>
    <ol start={5}>
      <li>
        <span>
          <strong> Security</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        5.1&nbsp; &nbsp;&nbsp;Taking into account the state of the art, the
        costs of implementation and the nature, scope, context and purposes of
        processing as well as the risk of varying likelihood and severity for
        the rights and freedoms of Data Subjects, the Processor shall implement
        appropriate technical and organizational measures to ensure a level of
        security appropriate to the risk, including inter alia as appropriate:
      </span>
    </p>
    <ul>
      <li>
        <span>The pseudonymization and encryption of the Personal Data;</span>
      </li>
      <li>
        <span>
          The ability to ensure the ongoing confidentiality, integrity,
          availability and resilience of processing systems and services;
        </span>
      </li>
      <li>
        <span>
          The ability to restore the availability and access to the Personal
          Data in a timely manner in the event of a physical or technical
          incident;
        </span>
      </li>
      <li>
        <span>
          A process for regularly testing, assessing and evaluating the
          effectiveness of technical and organizational measures for ensuring
          the security of the processing.
        </span>
      </li>
    </ul>
    <p>
      <span>
        5.2&nbsp; &nbsp;&nbsp;In assessing the appropriate level of security,
        the Processor shall consider in particular the risks that are presented
        by processing, in particular from accidental or unlawful destruction,
        loss, alteration, unauthorized disclosure of, or access to the Data
        transmitted, stored or otherwise processed.
      </span>
    </p>
    <ol start={6}>
      <li>
        <span>
          <strong> Sub-Processor</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        6.1&nbsp; &nbsp;&nbsp;The Processor shall not engage another processor
        (a “Sub-Processor”) without prior specific or general written
        authorization of the Controller. In the case of general written
        authorization, the Processor shall inform the Controller of any intended
        changes concerning the addition or replacement of other Sub-Processors,
        thereby giving the Controller the opportunity to object to such changes.
        The Controller may object to such changes in writing within fifteen (15)
        days from receipt of the notice on changes.
      </span>
    </p>
    <p>
      <span>
        {' '}
        6.2&nbsp; &nbsp;Where the Processor engages Sub-Processor for carrying
        out specific processing activities on behalf of the Controller, the same
        data protection obligations as set forth in this DPA shall be imposed on
        that other Sub-Processor by way of a contract or other legal mechanisms
        to provide sufficient guarantees by the Sub-Processor that it will
        implement appropriate technical and organizational measures in such a
        manner that the processing will meet the requirements of the applicable
        laws, statutes and regulations. Where any Sub-Processor fails to fulfil
        its data protection obligations, the Processor shall remain fully liable
        to the Controller for the performance of that Sub-Processor’s
        obligations.
      </span>
    </p>
    <ol start={7}>
      <li>
        <span>
          <strong> &nbsp;Data Subject&nbsp;Rights</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        7.1&nbsp; &nbsp; &nbsp;Taking into account the nature of the processing,
        the Processor shall assist the Controller by appropriate technical and
        organizational measures, insofar as this is possible, for
        the&nbsp;fulfillment&nbsp;of the Controller’s obligations, as reasonably
        understood by the Controller, to respond to requests to exercise Data
        Subject rights under the GDPR.
      </span>
    </p>
    <p>
      <span>7.2&nbsp; &nbsp;&nbsp;The Processor shall:</span>
    </p>
    <ul>
      <li>
        <span>
          Promptly notify the Controller if the Processor or a Sub-Processor
          receives a request from a Data Subject under GDPR or other applicable
          law, statute or regulation in respect of the Personal Data; and
        </span>
      </li>
      <li>
        <span>
          Ensure that the Processor or such Sub-Processor do not respond to that
          request except on the documented instructions of the Controller or as
          required by applicable laws to which the Processor or Sub-Processor is
          subject, in which case the Processor shall to the extent permitted by
          applicable laws inform the Controller of that legal requirement before
          the Processor or Sub-Processor respond to the request.
        </span>
      </li>
    </ul>
    <ol start={8}>
      <li>
        <span>
          <strong>Data&nbsp;Breach</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        8.1&nbsp; &nbsp; &nbsp;The Processor shall notify the Controller without
        undue delay after becoming aware of a Data Breach affecting the Personal
        Data, providing the Controller with sufficient information to allow the
        Controller to meet any obligations to report or inform appropriate
        authorities and Data Subjects where necessary of the Data
        Breach.&nbsp;&nbsp;
      </span>
      <br />
      <span>
        {' '}
        8.2&nbsp; &nbsp;&nbsp;The Processor shall co-operate with the Controller
        and take such reasonable commercial steps as are directed by the
        Controller to assist in the investigation, mitigation and remediation of
        each such Data Breach.
      </span>
    </p>
    <ol start={9}>
      <li>
        <span>
          <strong>
            Data Protection Impact Assessment and Prior&nbsp;Consultation
          </strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        9.1&nbsp; &nbsp;&nbsp;The Processor shall provide reasonable assistance
        to the Controller with any Data Protection Impact Assessments, and prior
        consultations with competent data privacy authorities, which the
        Controller reasonably considers to be required by the GDPR or equivalent
        provisions of any other applicable law, in each case solely in relation
        to processing of the Personal Data by, and considering the nature of the
        processing and information available to, the Processor.
      </span>
    </p>
    <ol start={10}>
      <li>
        <span>
          <strong> Deletion or Return of the&nbsp;Data</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        10.1&nbsp; &nbsp; &nbsp;Subject to sections 10.2 and 10.3 the Processor
        and each Sub-Processor, if any, shall promptly and in any event within
        thirty (30) days of the date of cessation of any services involving the
        processing of the Personal Data (the “<strong>Cessation Date</strong>“),
        delete and procure the deletion of all copies of the Personal Data.
      </span>
    </p>
    <p>
      <span>
        10.2&nbsp; &nbsp; Subject to section 10.3, the Controller may in its
        absolute discretion by written notice to the Processor within seven (7)
        days of the Cessation Date require Processor and each Sub-Processor, if
        any, to return a complete copy of all Personal Data to the Controller by
        secure file transfer in such format as is reasonably notified by the
        Controller to the Processor; and&nbsp;
      </span>
    </p>
    <p>
      <span>
        10.3&nbsp; &nbsp;&nbsp;The Processor may retain the Personal Data to the
        extent required by applicable laws and only to the extent and for such
        period as required by applicable laws and always provided that the
        Processor ensures the confidentiality of all such Personal Data and
        ensures that such Personal Data is only processed as necessary for the
        purpose(s) specified in the applicable laws requiring its storage and
        for no other purpose.
      </span>
    </p>
    <p>
      <span>
        10.4&nbsp; &nbsp;&nbsp;The Processor shall provide written certification
        to the Controller that the Processor has fully complied with this
        Section 10 within sixty (60) days of the Cessation Date.
      </span>
    </p>
    <ol start={11}>
      <li>
        <span>
          <strong> &nbsp;Audit&nbsp;Rights</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        11.1&nbsp; &nbsp; &nbsp; Subject to provisions of this Section 11, the
        Processor shall make available to the Controller on request all
        information necessary to demonstrate compliance with this DPA, and shall
        allow for and contribute to audits, including inspections, by the
        Controller or an auditor designated by the Controller in relation to the
        processing of the Data.&nbsp; The Controller shall pay for the costs of
        any such audit.&nbsp;
      </span>
    </p>
    <ol start={12}>
      <li>
        <span>
          <strong>Indemnification</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        13.1&nbsp;&nbsp; The Controller shall indemnify the Processor and any
        Sub-Processors from a claim from a third party resulting from a
        violation of its obligations as a Controller.
      </span>
    </p>
    <p>
      <span>
        13.2&nbsp;&nbsp; The Processor shall indemnify the Controller from a
        claim from a third party resulting from a violation of its obligations
        as Processor.
      </span>
    </p>
    <ol start={13}>
      <li>
        <span>
          <strong> Miscellaneous&nbsp;Provisions</strong>
        </span>
      </li>
    </ol>
    <p>
      <span>
        12.1&nbsp;&nbsp;&nbsp;&nbsp; Any matter that is not regulated by this
        DPA shall be governed by the MSA or any Statement of Work or Order
        concluded or exchanged between the parties to this DPA concerning the
        specific Processing to be undertaken by the Processor.
      </span>
    </p>
    <p>
      <span>
        12.2&nbsp; &nbsp; If any part of this DPA is found to be invalid,
        illegal or unenforceable in any respect, it will not affect the validity
        or enforce-ability of the remainder of this DPA or the MSA.
      </span>
    </p>
    <p>
      <span>
        12.3&nbsp; &nbsp; Any failure to exercise or enforce any right or the
        provision of this DPA shall not constitute a waiver of such right or
        provision.
      </span>
    </p>
    <p>
      <span>
        12.4&nbsp; &nbsp; The section titles in the DPA are for convenience only
        and have no legal or contractual effect.
      </span>
    </p>
  </div>
);

export const GDPRPage = () => (
  <Template>
    <GDPR />
  </Template>
);
